export enum BusinessObjectStatus {
    Active = "Active",
    Disabled = "Disabled",
    Deleted = "Deleted"
}